






































import Vue from 'vue';
import { mapActions } from 'vuex';
import Config from '../../../../configuration';

import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    methods: {
        ...mapActions('bh-roles', { findRole: 'find' }),
        ...mapActions('bh-quest-routin', { addQuestRoutin: 'create' }),
        ...mapActions('bh-promo-codes', { createQRCode: 'create', patchPromoCode: 'patch' })
    },
    components: {
        
    }
})
export default class QuestListsTable extends Vue {
    @Prop({ default() { return null; } })
    item!: any;

    @Prop({ default: null })
    type!: string;

    @Prop({ default: null })
    routin!: string;

    dialogAdd = false;
    dialogLoading = false;

    findRole: any;
    addQuestRoutin: any;
    createQRCode: any;
    patchPromoCode: any;

    form = {
        name: this.item ? this.item.name : null,
        icon: this.item ? this.item.icon : null,
        badge: this.item ? this.item.badge : null,
        code: this.item ? this.item.code : null,
        description: this.item ? this.item.description : null,
        points: this.item ? this.item.points : null,
        meta_url: this.item ? this.item.meta_url : null
    };

    selectedImages = {
        icon: null,
        badge: null
    };

    public valueComparison(a: any, b: any) {
        return a === b;
    }

    @Watch('dialog')
    ResetForm(nv: boolean) {
        if(nv) {
            this.form = {
                name: this.item ? this.item.name : null,
                icon: this.item ? this.item.icon : null,
                badge: this.item ? this.item.badge : null,
                code: this.item ? this.item.code : null,
                description: this.item ? this.item.description : null,
                points: this.item ? this.item.points : null,
                meta_url: this.item ? this.item.meta_url : null
            };
            this.selectedImages = {
                icon: null,
                badge: null
            };
        }
    }

    public async submit() {
        this.dialogLoading = true;
        try {
            if(!this.form.code || !this.form.description || !this.form.points) {
                throw new Error('Please complete the form!');
            }

            if(this.selectedImages.icon && (this.selectedImages.icon as any) instanceof File) {
                const iconImage = await this.toBase64(this.selectedImages.icon);
                const iconImageS3File = await fetch(`${Config.host}/api/upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': window.localStorage.getItem('feathers-jwt')
                    },
                    body: JSON.stringify({
                        uri: iconImage
                    })
                } as any).then(data => data.json());
                this.form.icon = `https://api.breakinghits.com/public/${iconImageS3File.id}`;
            }

            if(this.selectedImages.badge && (this.selectedImages.badge as any) instanceof File) {
                const badgeImage = await this.toBase64(this.selectedImages.badge);
                const badgeImageS3File = await fetch(`${Config.host}/api/upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': window.localStorage.getItem('feathers-jwt')
                    },
                    body: JSON.stringify({
                        uri: badgeImage
                    })
                } as any).then(data => data.json());
                this.form.badge = `https://api.breakinghits.com/public/${badgeImageS3File.id}`;
            }
            this.form.code = this.form.code.replace(/[\W_]+/g, '');
            if(this.item !== null) {
                this.patchPromoCode([this.item.id, this.form]);
            } else {
                await this.createQRCode(this.form);
            }
            this.dialogAdd = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogLoading = false;
        }
        // console.log('test');
    }

    public async toBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
}
